export default __webpack_public_path__ + "static/media/thirdlaw.f653137d.jpg";